import React from 'react';
import { valueToPC } from '../Bids/Bids.tsx';
import { Card } from '../Card/Card.tsx';
import './Cards.scss';

export const Cards = (props) => {
	const { cards, small, showPc } = props;

	return (
		<>
			<div className={`cards-wrapper${small ? ' small' : ''}`}>
				{showPc && (
					<p className="cards__pc">{cards?.reduce((acc, card) => acc + valueToPC(card.value), 0)}PC</p>
				)}
				<div className={`cards${small ? ' small' : ''}`}>
					{cards && cards.map((card, index) => <Card card={card} index={index} key={index} />)}
				</div>
			</div>
		</>
	);
};
